<template>
  <div class="bk-main-canvas relative">
    <HeadFavicon />

    <ClientOnly v-if="user.canAccessToolbar && !isEditing">
      <LazyAdminBar />
    </ClientOnly>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    
  </div>
</template>

<script setup lang="ts">
import { buildFastlyCacheTags } from '~/server/utils/cacheability'

const route = useRoute()
const user = await useDrupalUser()
const language = useCurrentLanguage()
const { activeDomain } = useSiteContext()

const isEditing = computed(
  () =>
    !!(route.query.blokkliEditing || route.query.blokkliPreview) &&
    user.canAccessToolbar,
)

const { isPartyMode } = usePartyToggle()

const classes = computed(() => {
  return isPartyMode.value ? 'is-party-mode' : ''
})

useHead({
  htmlAttrs: {
    lang: language.value,
    class: classes,
  },
})

useCDNHeaders((v) =>
  v.addTags(buildFastlyCacheTags(['domain:' + activeDomain])).public(),
)
</script>

<style lang="postcss">
/* blökkli overrides for dark mode. */
.bk-html-root {
  @media (prefers-color-scheme: dark) {
    #nuxt-root {
      @apply !bg-black-bis;
      .bk-main-canvas {
        @apply !bg-background;
      }
    }
  }
}

.bk .bk-edit-indicator {
  z-index: 600 !important;
}

.bk {
  color: black;
}

.bk-library-list-item-inner {
  @apply dark:bg-background;
  &:after {
    @apply dark:hidden;
  }
}

.bk-anchor-indicator {
  @apply relative;
  border-top: 2px solid rgb(var(--bk-theme-red-normal));
}

.bk-anchor-pill {
  color: rgb(var(--bk-theme-red-normal));
  @apply absolute right-full top-1/2 mr-2 flex -translate-y-1/2 items-center gap-1.5 whitespace-nowrap text-base font-bold;
  > div {
    background: rgb(var(--bk-theme-red-normal));
    color: white;
    @apply flex size-[1.5em] items-center justify-center rounded-full p-1;
  }
}
</style>
